const namespace = 'notifies'

export const loadingSelector = state => {
  return state[namespace].get('fetching')
}

export const entriesSelectors = state => {
  return state[namespace].get('entries')
}

export const totalSelector = state => {
  return state[namespace].get('total')
}
export const notifyCountSelector = state => {
  return state[namespace].getIn(['notify', 'total'])
}
export const noDoFeedbackNum = state => {
  return state[namespace].get('noDoFeedbackNum')
}
export const replyRefreshKey = state => {
  return state[namespace].get('replyRefreshKey')
}